class I18nService {
  isAvailable() {
    return globalThis.Granite?.I18n !== undefined;
  }

  t(key, ...vars) {
    if (typeof key !== 'string') {
      return key;
    }

    if (this.isAvailable()) {
      try {
        return globalThis.Granite.I18n.get(key, ...vars);
      } catch (error) {
        console.warn('I18n translation error:', error);
        return key;
      }
    }

    return key;
  }
}

const i18nService = new I18nService();

export default i18nService;
